import eliza from '../img/beautyandfashion/Eliza.png'
import happy_peals from '../img/beautyandfashion/Happy-Petals.png'
import eternal_flower from '../img/beautyandfashion/Eternal-Flowers.png'
import serena from '../img/beautyandfashion/Serena.png'
import vip from '../img/beautyandfashion/VIP.png'
import zeus from '../img/beautyandfashion/Zeus.png'
import beauty_angel from '../img/beautyandfashion/Beauty-Angel.png'
import nail_fairy from '../img/beautyandfashion/Nail-Fairy.png'
import laser_care from '../img/beautyandfashion/Laser-Care-Clinic.png'
import spa_signature from '../img/beautyandfashion/Spa-Signature.png'
import wah_wah_win from '../img/beautyandfashion/Sun-Shine.png'
import hebe from '../img/beautyandfashion/HEBE.png'
import the_beauty_hair_sloon from '../img/beautyandfashion/The-Beauty-Hair-Saloon.png'
import kan_kaw_myaing from '../img/beautyandfashion/Kan-Kaw-Myaing.png'
import mogok_pauk_pauk from '../img/beautyandfashion/Mogok-Pauk-Pauk.png'
import pyae_soe_aung from '../img/beautyandfashion/Pyae-Soe-Aung.png'
import ma_myint_zu from '../img/beautyandfashion/Designer-Ma-Myint-Zu.png'
import latt_latt from '../img/beautyandfashion/Latt-Latt.png'
import ma_pont from '../img/beautyandfashion/Designer-Ma-Pont-(My-Favourite).png'
import thin_su_htwe from '../img/beautyandfashion/Thwin-Su-Htwe.png'
import yone_yone from '../img/beautyandfashion/Designer-Yone-Yone.png'
import kaung_myat from '../img/beautyandfashion/Designer-Kaung-Myat.png'
import myanmar_metropolitan_collage from '../img/education/MMC.png'
import premium_education_center from '../img/education/Premium-Education-Centre.png'
import locale from '../img/fandb/Locale.png'
import the_pansodan from '../img/fandb/The-Pansodan.png'
import port_autonomy from '../img/fandb/Port-Autonomy.png'
import ren_hot_pot from '../img/fandb/Ren-Hot-Pot.png'
import spicy_monster from '../img/fandb/Spicy-Monster.png'
import queen_roll_icecrean from '../img/fandb/Queens-Roll.png'
import paradise_bakery from '../img/fandb/Paradise-Bakery.png'
import ba_ya_the from '../img/fandb/Ba-Ya-Thae.png'
import sport_club from '../img/fandb/Sports-Club.png'
import the_grand from '../img/fitness/The-Grand.png'
import community_pool from '../img/fitness/Community-Pool.png'
import all_star_kid from '../img/fitness/All-Star-Kids.png'
import all_star_fitness from '../img/fitness/All-Star-Fitness.png'
import urban from '../img/homeimprovement/Urban-Furniture.png'
import beko from '../img/homeimprovement/Beko.png'
import the_solution from '../img/homeimprovement/The-Solution.png'
import shwe_la_yaung from '../img/homeimprovement/Shwe-La-Yaung.png'
import golden_home from '../img/homeimprovement/Golden-Home.png'
import index_furniture from '../img/homeimprovement/Index-Furniture.png'
import areca from '../img/homeimprovement/Areca.png'
import dream_master from '../img/homeimprovement/Dream-Master.png'
import awei_metta from '../img/leisureandtravel/Awei-Metta.png'
import awei_pila from '../img/leisureandtravel/Awei-Pila.png'
import hotel_sugatti from '../img/leisureandtravel/Hotel-Suggati.png'
import keinnara_loikaw from '../img/leisureandtravel/Keinnara-Loikaw.png'
import keinnara_pha_an from '../img/leisureandtravel/Keinnara-hpa-an.png'
import mo_mo_playground from '../img/leisureandtravel/Mo-Mo-Play-Playground.png'
import villa_inle from '../img/leisureandtravel/Villa-Inle.png'
import tharabar_gate from '../img/leisureandtravel/Tharabar-Gate.png'
import bliss from '../img/leisureandtravel/Bliss.png'
import double_nine from '../img/leisureandtravel/Double-Nine.png'
import royal_peace from '../img/homeimprovement/royalpeace.png'
import parami_gas from '../img/homeimprovement/Parami.png'
import love_nest from '../img/homeimprovement/lovenest.png'
import teka from '../img/homeimprovement/teka.png'
import slumberland from '../img/homeimprovement/slumberland.png'
import myaniture from '../img/homeimprovement/myaniture.png'
import sb from '../img/homeimprovement/sb.png'
import lashill from '../img/homeimprovement/lashill.jpg'
import wine_house from '../img/fandb/Wine-House.png'




const beauty_and_fashion = [
    {
        name: "Eliza",
        image: eliza,
        benefit: "20% Off Facial Service, 10% Off Facial Products",
        inquiry: "09 - 444 928 278",
        location: "No.40, Kyun Taw Road, San Chaung Township, Yangon, Myanmar."
    },
    {
        name: "Happy Petals Floral Service",
        image: happy_peals,
        benefit: "10% Off for flowers",
        inquiry: "09 - 516 3518",
        location: "No. 13, Okkyin Buta Yone Street, Hlaing Tsp."
    },
    {
        name: "Eternal Flower Floral Service",
        image: eternal_flower,
        benefit: "10% off for all service in all branches",
        inquiry: "09-513 9035",
        location: "449, New University Avenue, Bahan Township, Yangon."
    },
    {
        name: "Serena Beauty Saloon & Spa",
        image: serena,
        benefit: "10% off all Services",
        inquiry: "09-518 0069",
        location: "A1 (Wing-A), Ground Floor, Star City, Thanlyin Tsp."
    },
    {
        name: "VIP Spa & Massage",
        image: vip,
        benefit: "10% off all Services",
        inquiry: "09-254 863 677",
        location: "No. 1034, Kha Yay Street, North Dagon Township, Yangon."
    },
    {
        name: "Zeus Spa & Massage",
        image: zeus,
        benefit: "10% off all Services",
        inquiry: "09-407 349 090",
        location: "No. 94m Thamine Bayan Road, Tamwe, Yangon."
    },
    {
        name: "Beauty Angel",
        image: beauty_angel,
        benefit: "5% off all Services",
        inquiry: "09-252 022 022",
        location: "B-30, Myanmar Culture Valley, (MCV) U Wissara Road Dagon Township, Yangon."
    },
    {
        name: "Nail Fairy",
        image: nail_fairy,
        benefit: "20% off all Services",
        inquiry: "09-404 704 690",
        location: "G59, Urban Asia Center Corner of 48th Street & Maharbandula Street, Botahtaung Tsp, Yangon, Myanmar."
    },
    {
        name: "Laser Care",
        image: laser_care,
        benefit: "20% off all Services",
        inquiry: "09-302 00 777",
        location: "DMZ-No.25, Room 102, Yuzana Business Tower, Damazaydi Road, MyaeNiGone, San Chaung, Yangon."
    },
    {
        name: "Spa Signature",
        image: spa_signature,
        benefit: "15% off all Services",
        inquiry: "09-253 334 441",
        location: "No. 21B, Nat Mauk Yeik Thar Street, Yangon, Myanmar."
    },
    {
        name: "Wah Wah Win (Gold and Jewellary",
        image: wah_wah_win,
        benefit: "30 lakh above gift gold pandent, any jewellery gift, for city loft owner free delivery",
        inquiry: "01-226 584",
        location: "No.727, Mahabandoola Rd, Corner of 17th Street, Yangon."
    },
    {
        name: "HEBE Beauty Studio",
        image: hebe,
        benefit: "25% off for all packages",
        inquiry: "09-541 2305",
        location: "4B, Eaiksar Thaya Street, Tamwe, Yangon"
    },
    {
        name: "The Beauty Hair Saloon",
        image: the_beauty_hair_sloon,
        benefit: "20% off hair treatment, body treatment, foot massage",
        inquiry: "09-799 585 503",
        location: "No.33, Moe Kaung Street, Bauk Htaw, Yankin Tsp"
    },
    {
        name: "KanKawMyaing Fabric Shop",
        image: kan_kaw_myaing,
        benefit: "5% off for all items",
        inquiry: "09-950 500 521",
        location: "Room No. 1,2,3,4, Block no. 5. Thuwunna Market."
    },
    {
        name: "Designer Mogok Pauk Pauk",
        image: mogok_pauk_pauk,
        benefit: "10% off",
        inquiry: "",
        location: ""
    },
    {
        name: "Designer Pyae Soe Aung",
        image: pyae_soe_aung,
        benefit: "10% off",
        inquiry: "",
        location: ""
    },
    {
        name: "Designer Ma Myint Zu",
        image: ma_myint_zu,
        benefit: "10% off",
        inquiry: "01-537 252",
        location: "No. 38, C 1, Inya Road, Kamayut Township, Yangon."
    },
    {
        name: "Designer Latt Latt",
        image: latt_latt,
        benefit: "10% off",
        inquiry: "09-518 7885",
        location: "Building 59, Rm-7, Ground F1, Parami Housing, Kabar Aye Pagoda Rd, Mayangone Tsp, Yangon, Myanmar"
    },
    {
        name: "Designer Ma Pont",
        image: ma_pont,
        benefit: "10% off",
        inquiry: "",
        location: ""
    },
    {
        name: "Designer Thin Su Htwe",
        image: thin_su_htwe,
        benefit: "10% off",
        inquiry: "",
        location: ""
    },
    {
        name: "Designer Yone Yone",
        image: yone_yone,
        benefit: "10% off",
        inquiry: "09-951 157 33",
        location: "Building (21), Room 3-4, Martali Street, Hlaing Myint Mo Housing, Hlaing Tsp, Yanogn."
    },
    {
        name: "Designer Kaung Myat",
        image: kaung_myat,
        benefit: "10% off",
        inquiry: "",
        location: ""
    }

]

const educations = [
    {
        name: "Myanmar Metropolitan Collage",
        image: myanmar_metropolitan_collage,
        benefit: "10% Off",
        inquiry: "01 - 550069",
        location: "No. 232, Bagayar Street, Myay Ni Gone, Sanchaung Township, Yangon"
    },
    {
        name: "Premium Education Centre",
        image: premium_education_center,
        benefit: "50% off for registration fee",
        inquiry: "09-798 932 715",
        location: "FG 79, Sein Lei Kan Thar Street, FMI City, Hlaing Thar Yar, Yangon"
    }

]

const fan_db = [
    {
        name: "Locale",
        image: locale,
        benefit: "10% off all menu items",
        inquiry: "01-470 0017",
        location: "No.7-8, Kabar Aye Pagoda Road, Yangon"
    },
    {
        name: "The Pansodan",
        image: the_pansodan,
        benefit: "10% off all menu items",
        inquiry: "09-699 658 507",
        location: "106 Pansodan Road, Kyauktada Thwnship, Yangon"
    },
    {
        name: "Port Autonomy",
        image: port_autonomy,
        benefit: "10% off all menu items",
        inquiry: "01-392 263",
        location: "Strand Rd, Yangon, Myanmar"
    },
    {
        name: "Ren Hot Pot",
        image: ren_hot_pot,
        benefit: "10% off",
        inquiry: "09-420 169 811",
        location: "Wing-B, Star City, Thanlyin, Yangon"
    },
    {
        name: "Spicy Monster",
        image: spicy_monster,
        benefit: "10% off all menu items",
        inquiry: "09-752 422 425",
        location: "9D Waizayanta Street, Yangon, Myanmar"
    },
    {
        name: "Queens' Roll Icecream",
        image: queen_roll_icecrean,
        benefit: "15% off for ice cream",
        inquiry: "09-799 225 020",
        location: "3rd Floor, Mote Zay Tan Food Court, City Mall (St. John)"
    },
    {
        name: "Paradise Bakery",
        image: paradise_bakery,
        benefit: "10% off all menu items",
        inquiry: "09-772 797 821",
        location: "No.161, Corner of Lower Kyeemyindine road and marga street, Ahlone Tsp, Yangon"
    },
    {
        name: "Ba Ya Thae (Mont Hin Khar)",
        image: ba_ya_the,
        benefit: "5% off all menu items",
        inquiry: "09-968 047 009",
        location: "No. 83, Hledan Street middle block, Lanmadaw, Yangon"
    },
    {
        name: "Sports Club",
        image: sport_club,
        benefit: "10% off all",
        inquiry: "09-430 560 92",
        location: "Corner of Bo Tayza Street & Pyi Htaung Su Main Road, North Dagon tsp"
    },
    {
        name: "The Wine House Myanmar",
        image: wine_house,
        benefit: "5% (All Product)",
        inquiry: "+959 977296110, +959 950454563",
        location: "No.7 Shop House, Chan Thar Gone Yaung Condo Thanthumar Road, Tamwe Tsp, Yangon, Myanmar"
    }
]

const fitness = [
    {
        name: "The Grand (Aung Mingalar) Dental Clinic",
        image: the_grand,
        benefit: "5% for special treatment, 10% for general treatment for Thingan Gyun Branch",
        inquiry: "09-400 949 491",
        location: "369 Laydaungkan Road, 11071 Inside the Car Park of ibis Styles Yangon Stadium Hotel, Yangon"
    },
    {
        name: "Community Pool",
        image: community_pool,
        benefit: "10% off",
        inquiry: "09-425 285 385",
        location: "Kyaik Khauk Pagoda Road, Thanlyin Township, Star City Zone A, Yangon"
    },
    {
        name: "All Star Kids Playground",
        image: all_star_kid,
        benefit: "10% off",
        inquiry: "09-425 285 385",
        location: "Kyaik Khauk Pagoda Road, Thanlyin Township, Star City Zone A, Yangon"
    },
    {
        name: "All Star Fitness",
        image: all_star_fitness,
        benefit: "10% off",
        inquiry: "09-425 285 385",
        location: "Kyaik Khauk Pagoda Road, Thanlyin Township, Star City Zone A, Yangon"
    }
]

const home_improvement = [
    {
        name: "URBAN Furniture",
        image: urban,
        benefit: "15% off",
        inquiry: "09-423 880 944",
        location: "No. 123, Thityarpin Lane (3), Thuwuna Tsp, Yangon"
    },
    {
        name: "Beko Furniture",
        image: beko,
        benefit: "10% off",
        inquiry: "09 423 880 944",
        location: "A/8, Aung San Stadium East Wing, Upper Pansodan Road, Mingalar Taung Nyunt Tsp, Yangon"
    },
    {
        name: "The Solution Enterprise Co., Ltd",
        image: the_solution,
        benefit: "10% and 20% based on product",
        inquiry: "",
        location: "A1, Second Floor, Thiri Mingalar Old Market, Starnd Road, Kyee Myin Daing Tsp, Yangon"
    },
    {
        name: "Shwe La Yaung",
        image: shwe_la_yaung,
        benefit: "5% off for one year",
        inquiry: "09-730 64 486",
        location: "(No. 75/A,B,C), YaeTarShay Old Street, Bahan Tsp, Yangon"
    },
    {
        name: "Golden Home (Super Tower)",
        image: golden_home,
        benefit: "10% for any items",
        inquiry: "09-969 721 448",
        location: "Star City Building A3 (#25-32, #37-44,#49-51, #61-63)"
    },
    {
        name: "Index Furniture",
        image: index_furniture,
        benefit: "15% for 30 lakhs, 20% for 150 lakhs, 25% for 500 lakhs",
        inquiry: "09-969 721 448",
        location: "Index Furniture (Kabaraye Branch) No. 54B, Kabaraye Pagoda Road, MayanGone Tsp, Yangon Ph."
    },
    {
        name: "Dream Master (Matress)",
        image: dream_master,
        benefit: "15% off",
        inquiry: "09-952 000 095",
        location: "Yangon Showroom- Dagon Center (1), No.G-7, Ground Floor, Pyay Road, Sanchaung Tsp, Yangon"
    },
    {
        name: "Royal Peace Interior Design & Build",
        image: royal_peace,
        benefit: "5% off",
        inquiry: "09 430 590 33, 09 96 430 590 3",
        location: "No-B5-722, Star City Condominium, Kyaik Khauk Pagoda Road, Thanlyin Township, Yangon"
    },
    {
        name: "Star City Parami Gas (Dealer)",
        image: parami_gas,
        benefit: "2% off (12.5kg & 5kg)",
        inquiry: "09 258 984 077, 09 258 984 078",
        location: "No-B5-722, Star City Condominium, Kyaik Khauk Pagoda Road, Thanlyin Township, Yangon"
    },
    {
        name: "Love Nest",
        image: love_nest,
        benefit: "Furniture - up to 12% / Interior design and install up to  15%",
        inquiry: "09-5173480",
        location: "Tower B2 Ground Floor, Star City Compound, Kyaik Khauk Pagoda Road, Thanlyin Township, Yangon"
    }, 
    {
        name: "TEKA Myanmar",
        image: teka,
        benefit: "10% off ( Kitchen appliances taps & showers)",
        inquiry: "95 9 777 40 4500, + 95 9 777 40 4700",
        location: "No. 393, Lower Kyee Myin Daing Road, Ahlone Township, Yangon, Myanmar. / No (C-1), 33rd Street, Between 81th Street x 82th Street, Chan Aye Thar Zan Township, Mandalay, Myanmar."
    },
    {
        name: "Slumberland Myanmar",
        image: slumberland,
        benefit: "10% off (Mattress & bedding accessories)",
        inquiry: "09-964038009, 09-965136009",
        location: "No 43,44,45 (A001), Kyeemyin Daing Kanner Road, Kyeemyin Daing Township, Yangon, Myanmar"
    }, 
    {
        name: "Myaniture",
        image: myaniture,
        benefit: "5% off (terms and conditions apply)",
        inquiry: "09 250 164 386",
        location: "Room 2 GF, Building 110, Near 8 Mile Junction, Pyay Road"
    }, 
    {
        name: "SB Furniture",
        image: sb,
        benefit: "8% off",
        inquiry: "09887444405",
        location: "97/B, West Shwe Gondaing Road"
    },
    {
        name: "Las Hill",
        image: lashill,
        benefit: "Up to 10% off for card owner",
        inquiry: "09 770 775 355, 09 665 515 355",
        location: "No.67(C), Yuzana Condo, Corner of Kaba Aye Road & Shwe Gone Daing Road, Bahan Tsp"
    }
]

const leisure = [
    {
        name: "Awei Metta",
        image: awei_metta,
        benefit: "15% off on standard rate",
        inquiry: "01-368 779",
        location: "Pun Hlaing Estate in Hlaing Tharyar Tsp, Yangon"
    },
    {
        name: "Awei Pila",
        image: awei_pila,
        benefit: "15% off on standard rate",
        inquiry: "09-459 932 055",
        location: "North Bay, Pila Island, Mergui, Myanmar"
    },
    {
        name: "Hotel Sugatti",
        image: hotel_sugatti,
        benefit: "15% off on standard rate",
        inquiry: "057-202 5828",
        location: "Strand Rd, Mawlamyine, Myanmar"
    },
    {
        name: "Keinnara Loikaw",
        image: keinnara_loikaw,
        benefit: "15% off on standard rate",
        inquiry: "09-258 887 070",
        location: "U Khun Li Street, loikaw, Myanmar"
    },
    {
        name: "Keinnara Hpa-An",
        image: keinnara_pha_an,
        benefit: "15% off on standard rate",
        inquiry: "09-253 307 774",
        location: "Hpa An-Mt.Zwe Kabin Road, Hpa-An, Myanmar"
    },
    {
        name: "Mo Mo Play Playground",
        image: mo_mo_playground,
        benefit: "10 % off all services",
        inquiry: "09-442 155 267",
        location: "Myanamar Plaza, City Mall St John, Aeron Orange- Waizayantar,"
    },
    {
        name: "Villa Inle Hotel",
        image: villa_inle,
        benefit: "10 % off all services",
        inquiry: "09-428 354 320",
        location: "Maing Thauk Village, Inle Lake, Nyaung Shwe"
    },
    {
        name: "Tharabar Gate Hotel",
        image: tharabar_gate,
        benefit: "10 % off all services",
        inquiry: "061-246 0037",
        location: "Near Tharabar Gate, Old Bagan, Nyaung U Tsp, Bagan, Mandalay"
    },
    {
        name: "Bliss Photo Studio",
        image: bliss,
        benefit: "10 % off all services",
        inquiry: "09-443 366 627",
        location: "54 A, U Wisara Road, Industrial Zone , North Dagon Tsp, Yangon"
    },
    {
        name: "Double Nine",
        image: double_nine,
        benefit: "1000ks discount for local trip, internaional $3, Visa service 5000ks discount",
        inquiry: "01-231 6866",
        location: "15th Sreet, Lanmadaw Township, Yangon"
    }

]


export {
    beauty_and_fashion,
    educations,
    fan_db,
    fitness,
    home_improvement,
    leisure
}